export default function Guide() {
  return (
    <section>
      <h1>Tenzies</h1>
      <p>
        Roll until all the dice are same. Click each die to freeze at its
        current value between rolls
      </p>
    </section>
  );
}
